import { gql } from "@apollo/client";

const SAVE_INSUMO_CAPACITACION_AP = gql`
    mutation saveVisitaInsumoCapacitacionAP($input: AddVisitaInsumoCapacitacionInput!, $idTeleEnfermeria: Int!){
        saveVisitaInsumoCapacitacionAP(input: $input, idTeleEnfermeria: $idTeleEnfermeria) {
            idInsumoCapacitacion
        }
    }
`;

export default SAVE_INSUMO_CAPACITACION_AP;

export const adaptAddVisitaInsumoCapacitacionAPInput = (data) => ({
  idTeleEnfermeria: data?.idTeleEnfermeriaAP,
  input: {
    idInsumoCapacitacion: data?.idInsumoCapacitacion,
    insumoVencido: data?.insumoVencido,
    cantidadSuficiente: data?.cantidadSuficiente,
    reclamoCantidadCalidad: data?.reclamoCantidadCalidad,
    observacionCapacitacion: data?.observacionCapacitacion
  }
});